export default {
  auth_url: "https://rcd-api.veetal.app/auth",
  api_url: "https://rcd-api.veetal.app/api",
  analytics: {
    gaId: "G-RF31ZPWKXF"
  }
};
